export default __webpack_public_path__ + "static/media/790651384851595285.bbe49720.png";